import React from 'react';

export const Play = () => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.333008 14L11.9997 7L0.333008 0V14Z"
      fill="currentColor"
    />
  </svg>
);
